import { assetsGridContract, useDataGrid } from '@/modules/data-grid'

export const DESCENDANT_ONLY_COLUMNS = ['entity', 'entityId'] as const

export function useAssetsGrid(entityId: string | null, includeChildren: boolean) {
  return useDataGrid({
    contract: assetsGridContract,
    queryKey: ['assets', 'inventory', entityId ?? ''],
    endpoint: `/api/v1/entities/${entityId ?? ''}/assets`,
    hiddenColumns: includeChildren ? undefined : DESCENDANT_ONLY_COLUMNS,
    enabled: entityId !== null,
    savedViews: { landOnDefault: true },
  })
}
